module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-dpk",
    attrs: {
      "name": "hrms-timepicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputTime),
      expression: "inputTime"
    }],
    ref: "timePickerInput",
    staticClass: "input-timepicker align-center",
    class: {
      'input-error': _vm.hasError
    },
    attrs: {
      "maxlength": "5",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputTime)
    },
    on: {
      "blur": function($event) {
        _vm.calendarTime()
      },
      "keyup": function($event) {
        _vm.calendarTime()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputTime = $event.target.value
      }
    }
  }), _vm._v(" "), _c('time-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option,
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        _vm.changeInputTime(arguments[0])
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-885ba0e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsTimepicker/component.vue
// module id = 3922
// module chunks = 1